import React from 'react';

import Card from '../../components/Card/Card';
import FiveStarRating from '../../components/FiveStarRating/FiveStarRating';
import GqlQueryWrapper from '../../components/GqlQueryWrapper/GqlQueryWrapper';
import Table from '../../components/Table/Table';
import TablePreRender from '../../components/Table/Table.prerender';
import TitleWithDescription from '../../components/TitleWithDescription/TitleWithDescription';

import { MORNING_STAR_CATEGORY } from './queries';
import { morningStarCategoryUtil } from './util';
import { NA_DEFAULT } from '../../utils/Format/Format';
import { isUnsupportedByMorningstar } from '../../utils/fund-info';

import styles from './MorningstarRatingsTable.css';

const MorningstarRatingsTable = ({ ticker, iClass }) => (
    <GqlQueryWrapper
        query={MORNING_STAR_CATEGORY}
        variables={{ ticker }}
        dataFunc={morningStarCategoryUtil(ticker, iClass)}
        placeholder={() => <TablePreRender />}
    >
        {({
            data: { asOfDate, categoryName, data, title, tacked, shouldHide }
        }) => {
            if (shouldHide) return null;

            return (
                <React.Fragment>
                    <Card className="left">
                        <div className="subsection-no-border">
                            <div className="cat-container">
                                <TitleWithDescription title="Morningstar Category" />
                                <div className="category">
                                    {categoryName || `${NA_DEFAULT}`}
                                </div>
                            </div>
                            <TitleWithDescription
                                title={title}
                                rightText={() => `As of ${asOfDate}`}
                            />
                            <Table
                                data={{ data }}
                                render={(rating) => (
                                    <React.Fragment>
                                        {rating > 0 &&
                                        !isUnsupportedByMorningstar(ticker) ? (
                                            <FiveStarRating
                                                value={rating}
                                                hollow={tacked}
                                            />
                                        ) : (
                                            <div>{NA_DEFAULT}</div>
                                        )}
                                    </React.Fragment>
                                )}
                            />
                        </div>
                        {tacked && (
                            <div className="morningstar-footer-text">
                                <sup>◊</sup> Ratings displayed with hollow stars
                                represent Morningstar Extended Performance
                                Ratings. Morningstar provides adjusted
                                historical returns and an Extended Performance
                                Rating for some mutual fund share class that don{`'`}t
                                have a 1, 3-, 5-, or 10-year performance
                                history. These hypothetical Morningstar Ratings
                                are based on the historical performance of the
                                oldest share class of the fund, adjusted for
                                fees and expenses.
                            </div>
                        )}
                        <div className="morningstar-footer-text">
                            {asOfDate === NA_DEFAULT && (
                                <div>
                                    Funds must have at least three years of
                                    performance data before Morningstar will
                                    assign a star rating.<br />
                                    <br />
                                </div>
                            )}
                            Morningstar ratings are based on risk-adjusted
                            returns. The Morningstar Ratingᵀᴹ for funds, or{' '}
                            {`"`}star rating{`"`}, is calculated for funds with
                            at least a three-year history. Exchange-traded funds
                            and open-ended mutual funds are considered a single
                            population for comparative purposes. It is
                            calculated based on a Morningstar Risk-Adjusted
                            Return measure that accounts for variation in a
                            managed product{`'`}s monthly excess performance,
                            placing more emphasis on downward variations and
                            rewarding consistent performance. The top 10% of
                            products in each product category receive 5 stars,
                            the next 22.5% receive 4 stars, the next 35% receive
                            3 stars, the next 22.5% receive 2 stars, and the
                            bottom 10% receive 1 star. The Overall Morningstar
                            Rating for a managed product is derived from a
                            weighted average of the performance figures
                            associated with its three-, five-, and 10-year (if
                            applicable) Morningstar Rating metrics.<sup>*</sup>
                        </div>
                    </Card>
                    <style jsx>{styles}</style>
                </React.Fragment>
            );
        }}
    </GqlQueryWrapper>
);

export default MorningstarRatingsTable;
